export default __webpack_public_path__ + "static/media/img_option_a.062abc9a.svg";